import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getAeroPhotoTourLink = ({ offerData }: IState): string | null => {
  return pathOr<string | null>(null, ['newObject', 'panorama', 'url'], offerData);
};
